import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';

export class DressingBodyToSimpleSapElementMapper
    extends BaseElementToSimpleSapElementMapper {
    public map(element: Element): ISimpleSapElement[] {
        const type = this.formatType('TOL', 7, 0);
        const color = this.toColor(element);
        return [SimpleSapElement.ELEMENT(type, color)];
    }
}